module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/uri-ea5b73cafd4180f1fb0c86b46c2831df.png";